import Vue from "vue";
import store from "./stores";
import App from "./App.vue";
import scroll from "vue-seamless-scroll/src";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
Vue.use(VueQuillEditor, /* { default global options } */);
Vue.use(ElementUI, { locale });
Vue.use(scroll);
import { Quill } from "vue-quill-editor";
import Video from './utils/video'
Quill.register(Video,true)


import * as filters from "./filters";
Object.keys(filters).forEach((k) => {
    Vue.filter(k, filters[k]);
});

import router from "./routers";

import "@/styles/common.scss";
import "@/styles/element.scss";
import "@/styles/amap.scss";
import "font-awesome/css/font-awesome.css"; // font-awesome

import "./icons"; // icons 模块
import "./maxWindow";
// import Quill from "quill";
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
